import { createFileRoute } from '@tanstack/react-router'

import {Authorisation} from "@/lib/auth/components/auth-provider";
import Unauthorized from "@/lib/auth/components/unauthorized";
import {PERMISSIONS} from "@/lib/auth/roles";
import {isCurrentPage} from "@/lib/utils";
import ReviewSettings from "@/modules/review-settings";
import {sendShortReviewSettingQueryOptions} from "@/modules/review-settings/hooks";
import {DataLoader} from "@/types/router-context";
import {REVIEW_SETTINGS_PATH, REVIEW_SETTINGS_URL} from "@/utils/urls";

export const Route = createFileRoute(REVIEW_SETTINGS_PATH)({
  component: ReviewSettingsPage,
  loader: ({ context: { queryClient } }: DataLoader) => {
    if (isCurrentPage(REVIEW_SETTINGS_URL)) {
      return
    }
    queryClient.prefetchQuery(sendShortReviewSettingQueryOptions())
  },
  beforeLoad: () => {
    return {
      breadcrumbs: [
        {label: 'Settings', path: '#'},
        {label: 'Review settings', path: REVIEW_SETTINGS_URL},
      ],
      children: <div className={'h-10'}></div>
    }
  },
})

function ReviewSettingsPage() {
  return (
    <div className='flex flex-col items-center justify-center'>
      <Authorisation roles={[]} permissions={[PERMISSIONS.IS_FIRM_WIEW_OR_IS_NETWORK_VIEW_ON_NETWORK]}
        forbiddenFallback={<Unauthorized/>}>
        <ReviewSettings />
      </Authorisation>
    </div>
  )
}
